import React from 'react';
import { observer } from 'mobx-react-lite';
import globalUserProfile from '../../stores/global-user-profile';
import './unauthorized-content.css';

export const UnauthorizedContent: React.FC = observer(() => {
  const firstName = globalUserProfile.userProfile?.userWithRole.firstName || '';
  const lastName = globalUserProfile.userProfile?.userWithRole.lastName || '';

  return (
    <div className="unauthorized-content-container">
      <div className="unauthorized-content-box">
        <div className="unauthorized-content-icon">👋</div>
        <h1 className="unauthorized-content-title">
          ברוכים הבאים {firstName} {lastName}
        </h1>
        <p className="unauthorized-content-message">
          <img src="/diro-icon.png" alt="Diro" className="diro-icon-inline" />
          מערכת דירו
        </p>
      </div>
    </div>
  );
});

/*
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './unauthorized-content.css';

export const UnauthorizedContent: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/home');
  };

  return (
      <div className="unauthorized-content-container">
        <div className="unauthorized-content-box">
          <div className="unauthorized-content-icon">🚫</div>
          <h1 className="unauthorized-content-title">אופס!</h1>
          <p className="unauthorized-content-message">הגעת למקום הלא נכון</p>
          <button className="unauthorized-content-button" onClick={handleGoHome}>
            לחץ כאן למעבר לדף הבית
          </button>
        </div>
      </div>
  );
};
*/
